module.exports = __webpack_public_path__ + "img/flicker_escape.7e5c79a2.gif";